// src/hooks/useTrafficAnalytics.js
import { useState, useEffect, useCallback } from 'react';
import { auth } from '../firebase';

const FUNCTION_URL = 'https://us-central1-winnepocket-landscaping.cloudfunctions.net/getGA4Analytics';

const useTrafficAnalytics = (dateRange = '30d') => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [configured, setConfigured] = useState(true);

  const fetchTraffic = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = await auth.currentUser?.getIdToken();
      if (!token) throw new Error('Not authenticated');

      const response = await fetch(FUNCTION_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ dateRange }),
      });

      const json = await response.json();

      if (!response.ok) {
        throw new Error(json.error || `Server error ${response.status}`);
      }

      setData(json);
      setConfigured(true);
    } catch (err) {
      const msg = err.message || '';
      if (msg.includes('NOT_FOUND') || msg.includes('not deployed')) {
        setConfigured(false);
      } else {
        setError(msg);
      }
    } finally {
      setLoading(false);
    }
  }, [dateRange]);

  useEffect(() => {
    fetchTraffic();
  }, [fetchTraffic]);

  return { data, loading, error, configured, refresh: fetchTraffic };
};

export default useTrafficAnalytics;